module.exports = __webpack_public_path__ + "SF-UI-Display-Black.c76879fd632e4ec8f93a.otf";


//////////////////
// WEBPACK FOOTER
// D:/UI-PROJECTS/Helpline1097-UI/src/fonts/SF-UI-Display/SF-UI-Display-Black.otf
// module id = ../../../../../src/fonts/SF-UI-Display/SF-UI-Display-Black.otf
// module chunks = 2